import ActiveRecordResource from './ActiveRecordResource';
import config from 'config';
import {utility} from "../utilites/index";

export interface ShopStripeDto {
  stripe_account_id?: string
  stripe_account_onboarded: boolean
  stripe_account_ready: boolean

}

export class ShopStripe extends ActiveRecordResource {
  prefix = 'shop_stripe';
  stripe_account_id?: string
  stripe_account_onboarded: boolean
  stripe_account_ready: boolean

  static path = `${config.backOfficeBasePath}/payments/stripe/account-status`;

  static validateConstraints = {};

  static mapRecord(item) {
    return new ShopStripe(item);
  }
  
  static mapRecords(data) {
    return data.map((item) => new ShopStripe(item));
  }

  _getModel() {
    return ShopStripe;
  }
  
  // static action() {
  //   return async (dispatch) => {
  //     try {
  //       return utility.networkLayer.getJson(this.path).then(data => [this.mapRecord(data)]);
  //     }

  //     catch(error) {
  //       dispatch({
  //         type: `shop_stripe_item_fail`,
  //         error
  //       });

  //       throw error;
  //     }
  //   } 
  // }

  static parseData(data: ShopStripeDto) {
    let res = new ShopStripe({});
    return Object.assign(res, res._parseData(data));
  }

  _parseData(data: ShopStripeDto) {
    return {
      id: data.stripe_account_id,
      stripe_account_id: data.stripe_account_id,
      stripe_account_onboarded: data.stripe_account_onboarded,
      stripe_account_ready: data.stripe_account_ready
    }
  }
}

export default ShopStripe;



// WEBPACK FOOTER //
// ./src/api/shop_stripe.ts